import { render, staticRenderFns } from "./personal-infomation-list.vue?vue&type=template&id=0e98b752&scoped=true"
import script from "./personal-infomation-list.vue?vue&type=script&lang=js"
export * from "./personal-infomation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e98b752",
  null
  
)

export default component.exports